import React, { useRef } from "react";
import { SessionPhoto as IPhoto } from "../../../../Shared/GeneratedTypes";
import { CircularProgress } from "@material-ui/core";

interface PropTypes {
    photo: IPhoto;
    photoSelected: (photo: IPhoto) => void;
}
export default function Photo(props: PropTypes) {
    let photo = props.photo;
    const imageRef = useRef<HTMLImageElement>(null);
    return (
        <div className="photo" onClick={() => props.photoSelected(photo)}>
            {photo.url ? (
                <div className="photoContainer">
                    <img
                        ref={imageRef}
                        src={photo.thumbnailUrl}
                        onError={() => (imageRef.current!.src = photo.url!)}
                        alt="snapshot"
                    />
                </div>
            ) : (
                <div>
                    <CircularProgress />
                </div>
            )}
            {/* {moment(photo.addedUTC).format("h:mm:ss")} */}
        </div>
    );
}
